import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import * as fromActions from './team.actions';
import {ITeam} from '@signal/asp-data-commons';

export interface TeamState extends EntityState<ITeam> {
  // additional entities state properties
  loading: boolean,
  loaded: boolean,
  empDetailsUpadated:boolean,
  error: string
}

export const adapter: EntityAdapter<ITeam> = createEntityAdapter<ITeam>();

export const initialState: TeamState = adapter.getInitialState({
  loading: false,
  loaded: false,
  empDetailsUpadated:false,
  error: ''
});


export function teamsReducer(
  state: TeamState = initialState,
  action: fromActions.TeamActions): TeamState {

  switch (action.type) {
    /* --------------- Loading team details --------------- */
    case fromActions.TeamActionTypes.LOAD_TEAMS: {
      const payload = action instanceof fromActions.LoadTeams ? action.payload : undefined;
      /* If no need to force reload AND if data is already loaded, return the current state */
      if (!payload.forceReload && state.loaded) {
        return state;
      }

      return {
        ...adapter.removeAll(state),
        loading: true,
        loaded: false,
        error: ''
      };
    }

    case fromActions.TeamActionTypes.LOAD_TEAMS_SUCCESS: {
      return {
        ...adapter.setAll(action instanceof fromActions.LoadTeamsSuccess ? action.payload.teams : [], state),
        loaded: true,
        loading: false,
        error: ''
      };
    }

    case fromActions.TeamActionTypes.LOAD_TEAMS_FAILURE: {
      return {
        ...state,
        loaded: false,
        loading: false,
        error: action instanceof fromActions.LoadTeamsFail ? action.payload.error : ''
      }
    }

    /* --------------- Adding a new team --------------- */
    case fromActions.TeamActionTypes.ADD_TEAM: {
      return {
        ...state,
        loading: true
      }
    }

    case fromActions.TeamActionTypes.ADD_TEAM_SUCCESS: {
      return {
        ...adapter.addOne(action instanceof fromActions.AddTeamSuccess ? action.payload.team : undefined, state),
        loading: false
      }
    }

    case fromActions.TeamActionTypes.ADD_TEAM_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action instanceof fromActions.AddTeamFail ? action.payload.error : ''
      }
    }

    /* --------------- Updating a team details --------------- */
    case fromActions.TeamActionTypes.UPDATE_TEAM: {
      return {
        ...adapter.updateOne(action instanceof fromActions.UpdateTeam ? action.payload.teamUpdate : undefined, state),
        loading: true
      }
    }

    case fromActions.TeamActionTypes.UPDATE_TEAM_SUCCESS: {
      return {
        ...state,
        loading: false

      }
    }

    case fromActions.TeamActionTypes.UPDATE_TEAM_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action instanceof fromActions.UpdateTeamFail ? action.payload.error : ''
      }
    }

    /* --------------- Deleting a team --------------- */
    case fromActions.TeamActionTypes.DELETE_TEAM: {
      return {
        ...adapter.removeOne(action instanceof fromActions.DeleteTeam ? action.payload.id : '', state),
        loading: true
      }
    }

    case fromActions.TeamActionTypes.DELETE_TEAM_SUCCESS: {
      return {
        ...state,
        loading: false
      }
    }

    case fromActions.TeamActionTypes.DELETE_TEAM_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action instanceof fromActions.DeleteTeamFail ? action.payload.error : ''
      }
    }

    /* Update employee details in the team */
    case fromActions.TeamActionTypes.UPDATE_EMPLOYEE_DETAILS: {
      const teamUpdate:any = action instanceof fromActions.UpdateEmployeeDetails ? action.payload.teamUpdate : [];
      const value = {
        ...adapter.updateMany(teamUpdate, state),
        empDetailsUpadated: false,
        loading: true
      }
      return value;
    }

    case fromActions.TeamActionTypes.UPDATE_EMPLOYEE_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        empDetailsUpadated:true

      }
    }

    case fromActions.TeamActionTypes.UPDATE_EMPLOYEE_DETAILS_FAILURE: {
      return {
        ...state,
        loading: false,
        empDetailsUpadated:false,
        error: action instanceof fromActions.UpdateEmployeeDetailsFail ? action.payload.error : ''
      }
    }


    default:
      return state;
  }
}
